
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { readHint } from "../../common/loginutils";
import AuthTransition from "../../components/authtransition";

function SsoStart() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    const startSso = async () => {
      try {
        console.log("[SsoStart] Current URL:", window.location.href);

        const hint = await readHint();
        const loginHint = hint?.login_hint;

        console.log("[SsoStart] Hint response:", hint);

        if (cancelled) return;

        if (loginHint) {
          sessionStorage.setItem("ssoLoginHint", loginHint);
          navigate("/login?ssoStart=true", { replace: true });
        } else {
          console.warn("[SsoStart] No login_hint found.");
          navigate("/login", { replace: true });
        }
      } catch (error) {
        if (cancelled) return;

        console.error(
          "[SsoStart] Unable to read Starfleet hint:",
          error
        );

        navigate("/login", { replace: true });
      }
    };

    startSso();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return <AuthTransition message="Redirecting to AppHub..." />;
}

export default SsoStart;
